import { useNotifications } from "../contexts/NotificationContext";
import { motion, AnimatePresence } from "framer-motion";

const NotificationStack = () => {
	const { notifications, removeNotification } = useNotifications();

	return (
		<div className='fixed top-4 right-[5%] z-50 space-y-2 max-w-md'>
			<AnimatePresence>
				{notifications.map((notification) => (
					<motion.div
						key={`${notification.id}-${notification.message}`}
						initial={{ opacity: 0, x: 100 }}
						animate={{ opacity: 1, x: 0 }}
						exit={{ opacity: 0, x: 100 }}
						className='bg-black/80 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2'>
						<span className='text-xl'>{notification.icon}</span>
						<p className='flex-1'>{notification.message}</p>
						<button
							onClick={() => removeNotification(notification.id)}
							className='text-white/60 hover:text-white transition-colors'>
							✕
						</button>
					</motion.div>
				))}
			</AnimatePresence>
		</div>
	);
};

export default NotificationStack;
